import CustomerClient from "@common/api/CustomerClient";
import { mapCustomersToOptions } from "@common/components/helpers/Customer/customers";
import CustomerFormAction from "@common/redux/actions/CustomerFormAction";
import { filterSelectedCustomerOptions } from "./filterCustomers";
import { handleError } from "../error";

export const searchCustomer = (
  searchQuery,
  selectedCustomers = null,
  includeImages = true,
) => {
  const queryIsPhoneNumber = !isNaN(searchQuery) && searchQuery !== "";
  const searchKey = queryIsPhoneNumber ? "phoneNumber" : "name";

  CustomerFormAction.setLoadingCustomers(true).then(() => {
    CustomerClient.Search({
      [searchKey]: searchQuery,
      pageNumber: 1,
      includeImages,
    })
      .then((response) => {
        const customerOptions = mapCustomersToOptions(response.data);
        const unselectedCustomerOptions = filterSelectedCustomerOptions(
          selectedCustomers,
          customerOptions,
        );
        CustomerFormAction.dispatch({
          customersResponse: response.data,
          customersOptions: unselectedCustomerOptions,
        });
      })
      .catch((error) => {
        console.error(error);
        handleError(error);
      })
      .finally(() => CustomerFormAction.setLoadingCustomers(false));
  });
};

export const fetchCustomerRowVersion = async (id) => {
  try {
    await CustomerFormAction.setLoadingCustomers(true);
    const response = await CustomerClient.UpdateMetaData(id);
    return response.record.rowVersion;
  } catch (error) {
    console.error(error);
    return "";
  } finally {
    CustomerFormAction.setLoadingCustomers(false);
  }
};

export const searchCustomerById = async ({ id, includeImages = true }) => {
  try {
    await CustomerFormAction.setLoadingCustomers(true);
    const response = await CustomerClient.Search({ id, includeImages });
    return response;
  } catch (error) {
    console.error(error);
    return "";
  } finally {
    CustomerFormAction.setLoadingCustomers(false);
  }
};

export const fetchCustomerById = async (id, includeImages = true) => {
  try {
    await CustomerFormAction.setLoadingCustomers(true);
    const response = await CustomerClient.Read(id);
    return response;
  } catch (error) {
    console.error(error);
    return "";
  } finally {
    CustomerFormAction.setLoadingCustomers(false);
  }
};
